import Handler from "../Handler";

export default class HandHistoryHandler extends Handler{
    execute(message){
        let receivedData = JSON.parse(message);
        this.service.processHandHistory(receivedData);
    }
}